import { Component, Input, OnInit } from '@angular/core';
import { IProcessEventMetadata, ISystemEvent } from 'src/app/shared/interfaces/system-event.interface';

@Component({
    standalone: false,
    selector: 'app-zoning-code-events-list',
    templateUrl: './zoning-code-events-list.component.html',
    styleUrls: ['./zoning-code-events-list.component.scss', '../../../../../shared/styles/mdl-table.scss']
})
export class ZoningCodeEventsListComponent implements OnInit {
    @Input()
    eventsList: ISystemEvent<IProcessEventMetadata>[];

    @Input()
    stateEnv: string;

    constructor() {}

    ngOnInit(): void {}
}
